import { render, staticRenderFns } from "./QuemSomos.vue?vue&type=template&id=367825f7&scoped=true&"
import script from "./QuemSomos.vue?vue&type=script&lang=js&"
export * from "./QuemSomos.vue?vue&type=script&lang=js&"
import style0 from "./QuemSomos.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./QuemSomos.vue?vue&type=style&index=1&id=367825f7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367825f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
